export const AUTH_SERVER_URL = `${process.env.REACT_APP_API}/user`
export const SEARCH_SERVER_URL = `${process.env.REACT_APP_API}/elastic/api/elastic`
export const CLIENT_SERVER_URL = `${process.env.REACT_APP_API}/clients/api/client`
export const USER_SERVER_URL = `${process.env.REACT_APP_API}/user/api/user`
export const CASH_BOX_SERVER_URL = `${process.env.REACT_APP_API}/cashboxes/api/cashbox`
export const DEAL_SERVER_URL = `${process.env.REACT_APP_API}/deals/api/deal`
export const REPORT_SERVER_URL = `${process.env.REACT_APP_API}/report/api/report`
export const KB_EXCHANGE_SERVER_URL = `${process.env.REACT_APP_API}/integration/api/integration`
export const NOTIFICATION_SERVER_URL = `${process.env.REACT_APP_API}/mailing/api/mailing/sms/`
export const DIRECTORIES_URL = `${process.env.REACT_APP_API}/elastic/api/elastic/`
export const KB_DEAL_NUMBER_URL = `${process.env.REACT_APP_API}/deals/api/deal/`
export const MCS_MIGRATE_URL = `${process.env.REACT_APP_API}/mcs/api/mcs/migrate`
export const AUTOLOMBARD_REQUESTS_URL = `${process.env.REACT_APP_API}/auto-pawnshop/api/auto-pawnshop`
